import { useMemo } from "react";
import { useGetDocTypeList } from "./useDocTypesData";

export const useCallCenterUsers = () => {
    return useGetDocTypeList({
        qKey: ["GetCallCenterUsers"],
        doctype: "User",
        filters: [
            ["enabled", "=", 1],
            ["role_profile_name", "=", "Call Center"],
        ],
        fields: ["name", "full_name", "role_profile_name"],
        sortBy: "full_name asc",
        limit: 0,
    });
};

export const useCallCenterDraftOrders = () => {
    const { data: users, isLoading: usersLoading } = useCallCenterUsers();

    const callCenterUserNames = useMemo(() => {
        const list = Array.isArray(users) ? users : [];
        return list.map((u) => u?.name).filter(Boolean);
    }, [users]);

    const enabled = callCenterUserNames.length > 0;

    const ordersQuery = useGetDocTypeList({
        qKey: ["GetCallCenterDraftOrders", ...callCenterUserNames],
        doctype: enabled ? "Draft Table Order" : null,
        filters: enabled
            ? [
                  ["status", "=", "Draft"],
                  ["owner", "in", callCenterUserNames],
              ]
            : null,
        fields: [
            "name",
            "customer",
            "status",
            "creation",
            "modified",
            "amount",
            "owner",
            "delivery_provider",
            "designated_number",
        ],
        sortBy: "modified desc",
        limit: 200,
    });

    return {
        callCenterUsers: users || [],
        callCenterUsersLoading: usersLoading,
        callCenterUserNames,
        ...ordersQuery,
    };
};

